// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Section-module--wrapper--38QBe","heading":"Section-module--heading--xjHeO"};